// src/components/Pricing.jsx
import React from "react";
import "./Pricing.css";

function Pricing() {
  return (
    <section id="pricing" className="section">
      <div className="container">
        <div className="section-title">
          <h2>Cennik</h2>
        </div>
        <div className="pricing-grid">
          {/* Karta 1: Lekcja próbna */}
          <div className="pricing-card">
            <h3>Pierwsza Lekcja Próbna</h3>
            <p className="price-tagline">50% TANIEJ!</p>
            <div className="price">
              50 zł<span>/ 60 min</span>
            </div>
            <ul className="price-details">
              <li>✓ Diagnoza potrzeb i problemów</li>
              <li>✓ Ustalenie planu działania</li>
              <li>✓ Poznajmy się bez zobowiązań</li>
            </ul>
          </div>

          {/* Karta 2: Lekcja indywidualna - Wyróżniona */}
          <div className="pricing-card highlighted">
            <h3>Lekcja Indywidualna</h3>
            <p className="price-tagline">Standardowa współpraca</p>
            <div className="price">
              85-100 zł<span>/ 60 min</span>
            </div>
            <ul className="price-details">
              <li>✓ Indywidualne podejście</li>
              <li>✓ Materiały po każdych zajęciach</li>
              <li>✓ Pomoc w zadaniach domowych</li>
              <li>✓ Przygotowanie do sprawdzianów</li>
            </ul>
          </div>        
        </div>
        <p className="payment-info">
          Płatności przyjmowane są za pomocą przelewu.
        </p>
      </div>
    </section>
  );
}

export default Pricing;